/*

Flow by WeTheme (http://www.wetheme.com)
Custom JS

i.	Theme Specific
1.	Masonry

Last Update:
9th June 2016
Init

*/

// Fading on homepage blocks

$(window).load(function() {

	var homepageProductsBlock = $('.homepage-featured-grid-item');
	homepageProductsBlock.on('mouseenter mouseleave', function(e) {
	    homepageProductsBlock.not(this).stop(true).fadeTo('fast', e.type=='mouseenter'?0.2:1);
	});
	
	var homepageCollection = $('.homepage-collection-grid-item');
	homepageCollection.on('mouseenter mouseleave', function(e) {
	    homepageCollection.not(this).stop(true).fadeTo('fast', e.type=='mouseenter'?0.2:1);
	});
	
	var homepageInstagram = $('.homepage-instagram-indiv');
	homepageInstagram.on('mouseenter mouseleave', function(e) {
	    homepageInstagram.not(this).stop(true).fadeTo('fast', e.type=='mouseenter'?0.2:1);
	});

});

// Showing previews based on hero menu

$('.homepage-hero-content-overlay-menu-item').imagesLoaded( { background: true }, function() {
	
	$(".homepage-hero-text-advert-link").hover(
		function () {
			$('.homepage-hero-content-overlay-advert').fadeIn(1, function() {
				$(".homepage-hero-content-overlay-advert").addClass("active");
			});
		}, 
		function () {
			$('.homepage-hero-content-overlay-advert').fadeIn(1, function() {
				$(".homepage-hero-content-overlay-advert").removeClass("active");
				$(".homepage-hero-content-overlay-advert").css("display", "");
			});
		}
	);
	
		
	
		
	
		
	
		
	
						

});

// Mobile Blog

$(document).ready(function() {
	$("#homepage-blog-mobile").owlCarousel({
		singleItem: true,
		autoHeight: true
	});
	
	$("#homepage-collection-mobile").owlCarousel({
		singleItem: true,
		autoHeight: true
	});
	
});


$(document).ready(function() {
    var $window = $(window);

    function checkWidth() {
        var windowsize = $window.width();
        if (windowsize > 768) {
			
		    var context = $('.context');
		    var uiSticky = $('.ui.sticky');
		
		    if (context.height() > uiSticky.height()) {
			    $('.ui.sticky')
			      .sticky({
			        context: '.context',
			        bottomOffset : 50,
			        observeChanges: true
			      })
			    ;			    
		    }
			
        } else {
        	console.log(windowsize);
        }
        
    }
    // Execute on load
    checkWidth();   
    $(window).resize(checkWidth);
});

// Blog Masonry


var $grid2 = $('.blog-article-wrapper').masonry({
  // set itemSelector so .grid-sizer is not used in layout
  itemSelector: '.blog-grid-item',
  // use element for option
  columnWidth: '.blog-grid-item',
  gutter: '.blog-gutter-sizer',  
  percentPosition: true
});

// First homepage section finder

$(".homepage-indiv-section-wrapper:first").addClass( "first-homepage-block" )

// Accessible Menu JS

$(document).ready(function(){
	$(".site-nav").addClass("js");
	$(".site-nav li").hover(function(){
		$("ul",$(this)).fadeIn();
	},function(){
		$("ul",$(this)).fadeOut();	
	});
	$("a").focus(function(){ // hide drop downs
		$(".site-nav ul").fadeOut();
	});
	$(".site-nav li a").focus(function(){ // main nav anchor focus
		$("ul",$(this).parent()).fadeIn();
	});
	$(".site-nav li li a").unbind(); // unbind hide drop downs from sub nav anchors
});